import { ConfigProvider, Empty, Select } from "antd";
import React from "react";

interface OptionsProps {
  id?: number | string;
  name?: string;
}

interface SelectProps {
  className?: string;
  options: OptionsProps[];
  selectPlaceholder?: string;
  disabled?: boolean;
  allowClear?: boolean;
  popupClassName?: string;
  mode?: "multiple" | "tags" | undefined;
  defaultValue?: any;
  popupMatchSelectWidth?: any;
  onChange?: (value: string) => void;
  style?: any;
  value?: any;
}
const Selects = ({ ...props }: SelectProps) => {
  return (
    <ConfigProvider
      renderEmpty={() => (
        <Empty
          description={
            <span className="ghaith--select-empty">لا توجد بيانات</span>
          }
        />
      )}
    >
      <Select
        {...props}
        defaultValue={props?.defaultValue}
        labelInValue
        className={`ghaith--select ${props.className ?? ""}`}
        size="large"
        value={props.value}
        popupMatchSelectWidth={props.popupMatchSelectWidth}
        direction="rtl"
        style={props.style}
        disabled={props.disabled}
        placeholder={props.selectPlaceholder}
        onChange={props.onChange}
        dropdownStyle={{ direction: "rtl" }}
        options={props?.options?.map((option) => ({
          label: option.name,
          value: option.id,
        }))}
        showSearch={true}
        filterOption={(input: any, option: any) =>
          option.label?.toLowerCase().includes(input?.toLowerCase())
        }
        mode={props.mode}
        popupClassName={`ghaith--select-dropdown ${props.popupClassName ?? ""}`}
        allowClear={props?.allowClear ?? true}
      />
    </ConfigProvider>
  );
};

export default Selects;
